import type { PresenceUser } from '@corner/shared';
import { getCollabColor } from '../../lib/collabColors';

interface PresenceAvatarsProps {
  users: PresenceUser[];
  maxVisible?: number;
}

export default function PresenceAvatars({ users, maxVisible = 4 }: PresenceAvatarsProps) {
  if (users.length === 0) return null;

  const visible = users.slice(0, maxVisible);
  const overflow = users.length - maxVisible;

  return (
    <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      {visible.map((user, i) => {
        const cc = getCollabColor(user.userId);
        return (
        <div
          key={user.userId}
          title={user.displayName}
          style={{
            width: 26,
            height: 26,
            borderRadius: '50%',
            backgroundColor: cc.bg,
            border: '2px solid #FAF7F4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: i < visible.length - 1 ? -8 : 0,
            zIndex: visible.length - i,
            position: 'relative',
            flexShrink: 0,
            cursor: 'default',
          }}
        >
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt={user.displayName}
              style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover' }}
            />
          ) : (
            <span style={{ fontFamily: '"Geist", system-ui, sans-serif', fontSize: 9, fontWeight: 600, color: cc.text }}>
              {initials(user.displayName)}
            </span>
          )}
        </div>
        );
      })}
      {overflow > 0 && (
        <div
          style={{
            width: 26,
            height: 26,
            borderRadius: '50%',
            backgroundColor: '#9A8E82',
            border: '2px solid #FAF7F4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 0,
            position: 'relative',
            flexShrink: 0,
          }}
        >
          <span style={{ fontFamily: '"Geist", system-ui, sans-serif', fontSize: 9, fontWeight: 600, color: '#FFFFFF' }}>
            +{overflow}
          </span>
        </div>
      )}
    </div>
  );
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return name[0]?.toUpperCase() ?? '?';
}
